import { useState, useEffect, useRef } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './carousel.css'

const Popup = ({ text, onClose }) => {
    const popupRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    return (
      <div className="popup">
        <div className="popup-content" ref={popupRef}>
          <span className="close-btn" onClick={onClose}>&times;</span>
          <p>{text}</p>
        </div>
      </div>
    );
  };

const Carousel = () => {
    const [expanded, setExpanded] = useState(false);
    const [popupContent, setPopupContent] = useState(null);
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        const fetchTestimonials = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "testimonials"));
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                data.sort((a, b) => a.createdAt?.seconds - b.createdAt?.seconds);
            
                setTestimonials(data);
            } catch (error) {
                console.error("Error fetching testimonials: ", error);
            }
        };

        fetchTestimonials();
    }, []);
  
    const handleToggleExpand = (text) => {
      setPopupContent(text);
      setExpanded(true);
    };

    return (
        <>
            <AliceCarousel mouseTracking>
                {testimonials.map((item) => (
                    <div className='carou' key={item.id}>
                        <div className="carousel">
                            <img src={item.profile_pic_url} className="ppic" alt={item.name} />
                            <p className='name'>{item.name}</p>
                            <p className='designation'>{item.occupation}</p> 
                        </div>
                        <div className='rightside'>
                            <p className='text'>{item.testimonial}</p>
                            <button onClick={() => handleToggleExpand(item.testimonial)} className="expand-btn">
                                Load More
                            </button>
                        </div>
                    </div>
                ))}
            </AliceCarousel>
            {expanded && <Popup text={popupContent} onClose={() => setExpanded(false)} />}
        </>
    );
  };

export default Carousel